module.exports = __webpack_public_path__ + "static/img/18.a1facd6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/eng/18.png
// module id = yAHN
// module chunks = 0